import { SvgIcon, SvgIconProps } from '@mui/material';

const MenuClose = (props: SvgIconProps) => (
  <SvgIcon
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || '1em'}
    height={props.height || '1em'}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <mask
      id="mask0_7890_23865"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_7890_23865)">
      <path
        d="M3.49988 17.4998V15.9998H15.7114V17.4998H3.49988ZM19.4461 16.5478L14.8786 11.9998L19.4461 7.46126L20.4999 8.51526L16.9864 11.9998L20.4999 15.494L19.4461 16.5478ZM3.49988 12.7498V11.2498H12.7884V12.7498H3.49988ZM3.49988 7.99976V6.49976H15.7114V7.99976H3.49988Z"
        fill="currentColor"
      />
    </g>
  </SvgIcon>
);
export default MenuClose;
